"use client";

import { useState } from "react";
import Image from "next/image";

import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { AccountCircle } from "@mui/icons-material";
import { Button, MenuItem, Menu, IconButton } from "@mui/material";

import { loginRequest } from "@/lib/auth/msal";

import { useUi } from "@/context/util/ui";

const SignInButton = () => {
  const { instance } = useMsal();

  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const open = Boolean(anchorEl);

  const handleLogin = (loginType: string) => {
    setAnchorEl(null);
    instance.loginRedirect(loginRequest);
  };

  return (
    <div>
      <Button
        onClick={(event) => setAnchorEl(event.currentTarget)}
        color="inherit"
      >
        Login
      </Button>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => handleLogin("redirect")} key="loginRedirect">
          Sign in
        </MenuItem>
      </Menu>
    </div>
  );
};

const SignOutButton = (props: { avatar: string | null }) => {
  const { instance } = useMsal();

  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const open = Boolean(anchorEl);

  const handleLogout = (logoutType: string) => {
    setAnchorEl(null);
    instance.logoutRedirect();
  };

  return (
    <div>
      <IconButton
        onClick={(event) => setAnchorEl(event.currentTarget)}
        color="inherit"
      >
        {props.avatar ? (
          <Image
            alt="logged in user avatar"
            style={{ borderRadius: "28px" }}
            width={48}
            height={48}
            unoptimized
            src={props.avatar}
          />
        ) : (
          <AccountCircle />
        )}
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => handleLogout("redirect")}>Logout</MenuItem>
      </Menu>
    </div>
  );
};

export default function SignInSignOutButton() {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { avatar } = useUi();

  if (isAuthenticated) {
    return <SignOutButton avatar={avatar} />;
  } else if (
    inProgress !== InteractionStatus.Startup &&
    inProgress !== InteractionStatus.HandleRedirect
  ) {
    // inProgress check prevents sign-in button from being displayed briefly after returning from a redirect sign-in. Processing the server response takes a render cycle or two
    return <SignInButton />;
  } else {
    return null;
  }
}
